import { useQuery } from '@tanstack/react-query';

import { postData } from '..';

// Request type
export type DeliverabilityMetricsRequest = {
  FromDate: string;
  MarketingCampaignId: number;
  ToDate: string;
};

// Response types
export type EmailDeliverability = {
  Bounced: number;
  Clicked: number;
  Delivered: number;
  Dropped: number;
  MarketingEmailId: number;
  Opened: number;
  Sent: number;
  SpamReport: number;
  Unsubscribed: number;
};

export type SMSDeliverability = {
  Bounced: number;
  Delivered: number;
  Failed: number;
  GatePassedThrough: number;
  LinkClicked: number;
  MarketingSMSId: number;
  Sent: number;
  Unsubscribed: number;
};

export type PushDeliverability = {
  MarketingPushId: number;
  Opened: number;
  Sent: number;
};

export type DeliverabilityMetricsResponse = {
  EmailData: EmailDeliverability[];
  PushData: PushDeliverability[];
  SMSData: SMSDeliverability[];
};

export function useDeliverabilityMetrics(marketingCampaignId: number | null, fromDate: Date, toDate: Date) {
  return useQuery({
    queryKey: ['workflow-deliverability-metrics', marketingCampaignId, fromDate, toDate],
    staleTime: 5 * 60 * 1000,
    enabled: !!marketingCampaignId && !!fromDate && !!toDate,
    queryFn: async () => {
      if (!marketingCampaignId) {
        return null;
      }

      return postData<DeliverabilityMetricsRequest, DeliverabilityMetricsResponse>({
        endpoint: 'api/marketing-campaign/get-deliverability-metrics',
        payload: {
          MarketingCampaignId: marketingCampaignId,
          FromDate: fromDate.toISOString(),
          ToDate: toDate.toISOString(),
        },
      });
    },
  });
}
